<template>
  <!--  <v-expand-transition v-if="showUserPlayingTables && mobileMenu">-->
  <v-dialog
    v-if="mobileMenu"
    overlay-color="black"
    overlay-opacity=".7"
    v-model="showUserPlayingTables"
    @keydown.esc="closeModal"
    @click:outside="closeModal"
  >
    <v-card
      color="transparent"
      class="background-darkest-blur modal-border mb-1"
    >
      <v-card-title class="justify-center py-2 px-0">
        <v-row justify="start">
          <v-col cols="2" align-self="center" class="d-flex justify-start">
            <v-btn icon @click="closeModal">
              <v-icon class="success--text font-weight-bolder"
                >mdi-close</v-icon
              >
            </v-btn>
          </v-col>
          <v-col
            cols="8"
            align-self="center"
            class="d-flex justify-center border-bottom-success-1px"
          >
            <span class="secondary--text">
              {{ $translate("playingTables") }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card elevation="0" color="transparent" :loading="apiRequestPending">
        <template slot="progress">
          <v-progress-linear
            color="success"
            indeterminate
            height="2"
            class="position-absolute"
          ></v-progress-linear>
        </template>
        <v-card-text class="scrollable-list pt-1">
          <v-row
            justify="center"
            class="d-flex align-center mt-2"
            v-if="!apiRequestPending && userPlayingTableList.length === 0"
          >
            <v-col align-self="center" class="col-12 d-flex justify-center">
              <span class="success--text font-weight-bold">
                {{ $translate("noActiveTableAvailable") }}
              </span>
            </v-col>
          </v-row>
          <template
            v-if="!apiRequestPending && userPlayingTableList.length > 0"
          >
            <template v-for="(table, index) in userPlayingTableList">
              <PlayingTable :table="table" :index="index" />
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
  <!--    <v-col-->
  <!--      cols="12"-->
  <!--      align-self="center"-->
  <!--      class="d-flex justify-center my-tables-open"-->
  <!--      v-if="showUserPlayingTables && mobileMenu"-->
  <!--    >-->
  <!--      <v-row-->
  <!--        justify="center"-->
  <!--        class="my-table-mobile-min-width"-->
  <!--        :class="{ 'dynamic-width': apiRequestPending }"-->
  <!--      >-->
  <!--        <v-container class="pa-0 ma-0 my-table-scrollable-container">-->
  <!--          <v-col-->
  <!--            cols="12"-->
  <!--            align-self="center"-->
  <!--            class="d-flex justify-center mt-2"-->
  <!--            v-if="apiRequestPending"-->
  <!--          >-->
  <!--            <span v-if="apiRequestPending">-->
  <!--              <v-progress-circular-->
  <!--                indeterminate-->
  <!--                color="success"-->
  <!--                size="35"-->
  <!--              ></v-progress-circular>-->
  <!--            </span>-->
  <!--          </v-col>-->
  <!--          <v-col-->
  <!--            cols="12"-->
  <!--            align-self="center"-->
  <!--            class="d-flex justify-center mt-2"-->
  <!--            v-if="!apiRequestPending && userPlayingTableList.length === 0"-->
  <!--          >-->
  <!--            <span class="accent&#45;&#45;text font-size-xs">-->
  <!--              No active table available-->
  <!--            </span>-->
  <!--          </v-col>-->
  <!--          <template-->
  <!--            v-if="!apiRequestPending && userPlayingTableList.length > 0"-->
  <!--          >-->
  <!--            <template v-for="(table, index) in userPlayingTableList">-->
  <!--              <PlayingTable :table="table" :index="index" :key="index" />-->
  <!--            </template>-->
  <!--          </template>-->
  <!--        </v-container>-->
  <!--        <button @click="closeModal">-->
  <!--          <v-col-->
  <!--            cols="12"-->
  <!--            align-self="end"-->
  <!--            class="d-flex justify-center mt-5 pb-0 pt-5"-->
  <!--          >-->
  <!--            <span class="white&#45;&#45;text"> MY TABLES </span>-->
  <!--          </v-col>-->
  <!--        </button>-->
  <!--      </v-row>-->
  <!--    </v-col>-->
  <!--  </v-expand-transition>-->

  <v-row
    justify="center"
    id="main-table-row"
    class="fill-height"
    v-else-if="showUserPlayingTables && !mobileMenu"
  >
    <v-col cols="2" align-self="center" class="d-flex justify-start">
      <v-btn icon @click="closeModal">
        <v-icon class="success--text font-weight-bolder">mdi-close</v-icon>
      </v-btn>
    </v-col>
    <v-col
      cols="10"
      align-self="center"
      class="d-flex justify-end"
      id="desktop-table-header"
    >
      <v-btn icon :ripple="false">
        <v-icon class="mr-1" color="accent">mdi-ellipse-outline</v-icon>
      </v-btn>
      <span class="accent--text font-size-xs d-flex align-center pr-2 pr-xl-4">
        {{ $translate("myTables") }}
      </span>
    </v-col>
    <transition
      name="animate__fadeInOut"
      :enter-active-class="'animate__animated animate__fadeIn animate__delay-2s-list'"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <v-col
        cols="12"
        align-self="center"
        class="d-flex justify-center mt-2"
        v-if="!apiRequestPending && userPlayingTableList.length === 0"
      >
        <span class="accent--text font-size-small">
          {{ $translate("noActiveTableAvailable") }}
        </span>
      </v-col>
    </transition>
    <v-container
      class="pa-0 ma-0 scrollable-container"
      id="desktop-scrollable-container"
      fluid
    >
      <v-col
        cols="12"
        align-self="center"
        class="d-flex justify-center py-0"
        v-for="(table, index) in userPlayingTableList"
      >
        <transition
          name="animate__fadeInOut"
          :enter-active-class="
            'animate__animated animate__fadeIn animate__delay-' +
            (index + 2) +
            's-list'
          "
          leave-active-class="animate__animated animate__fadeOut"
          appear
        >
          <PlayingTable :table="table" :index="index" />
        </transition>
      </v-col>
    </v-container>
  </v-row>
</template>

<script>
import Services from "@/services/user-services.js";
import { mapGetters } from "vuex";
import PlayingTable from "@/components/Modals/UserPlayingTables/PlayingTable";

export default {
  name: "UserPlayingTables",
  components: { PlayingTable },
  props: { showUserPlayingTables: Boolean },
  data() {
    return {
      apiRequestPending: false,
      userPlayingTableList: [],
      isImageLoaded: false,
      tableImgSource: require("@/assets/blue-table/2players.svg"),
    };
  },
  computed: {
    ...mapGetters(["getLastClubId", "mobileMenu"]),
  },
  methods: {
    closeModal() {
      this.$emit("toggleShowUserPlayingTables");
    },
    openGameTable(clubId, tableId) {
      this.$router.push(`/game/${tableId}/${clubId}`);
    },
    //  APIs
    getUserPlayingTables() {
      this.apiRequestPending = true;
      Services.get(`tables/user-tables-list`).then(
        (res) => {
          this.userPlayingTableList = res.body;
          this.apiRequestPending = false;
        },
        (error) => {
          this.apiRequestPending = false;
          console.log("Error occurred on fetching user playing tables...");
          Services.apiError(error.body.message, error.status);
        }
      );
    },

    adjustContainerHeight() {
      const mainRowEl = document.querySelector("#main-table-row");
      if (mainRowEl) {
        const mainRow = mainRowEl.offsetHeight;
        const headerHeight = document.querySelector(
          "#desktop-table-header"
        ).offsetHeight;

        document.querySelector(
          "#desktop-scrollable-container"
        ).style.maxHeight = `${mainRow - headerHeight - 10}px`;
      }
    },
    clearData() {
      this.userPlayingTableList = [];
    },
  },
  // Method Ends Here
  watch: {
    //  Only When the Modal is Open
    showUserPlayingTables(value) {
      if (value) {
        this.getUserPlayingTables();
        this.$nextTick(() => {
          this.adjustContainerHeight();
          window.addEventListener("resize", this.adjustContainerHeight);
        });
      } else {
        this.clearData();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustContainerHeight);
  },
};
</script>

<style scoped>
/*.my-tables-open {*/
/*  background: rgba(194, 179, 153, 0.36) 0% 0% no-repeat padding-box;*/
/*  border: 1px solid #707070;*/
/*  opacity: 1;*/
/*  backdrop-filter: blur(12px);*/
/*  -webkit-backdrop-filter: blur(12px);*/
/*  border-radius: 40px 40px 25px 25px;*/
/*}*/

/*.my-table-scrollable-container {*/
/*  height: 25vh;*/
/*  overflow-y: auto;*/
/*  overflow-x: hidden;*/
/*}*/
/*.my-table-mobile-min-width {*/
/*  min-width: 36vh !important;*/
/*}*/
/*.dynamic-width {*/
/*  width: 36vh !important;*/
/*}*/
/*@media only screen and (max-height: 700px) {*/
/*  .dynamic-width {*/
/*    width: 44vh !important;*/
/*  }*/
/*}*/
.scrollable-list {
  height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.scrollable-container {
  min-height: 20vh;
  max-height: 26vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
